import FlourishComponent from 'components/FlourishComponent';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RegionalHeatmapChart = ({ data, containerId, title = 'Map Chart' }, ref) => {
  const [chartLoaded, setChartLoaded] = React.useState(false);
  if (!data) return null;

  const max = Math.max(...data.slice(1).map((row) => Number(row[3])));

  return (
    <Row className='report-second d-flex to-break w-100 p-0 mb-0'>
      <Col className={`simple-box d-flex flex-column justify-content-center col-12 mb-0`}>
        <Row className='ml-0'>
          <h5 className='title-simple-box text-uppercase mt-1 pl-0'>
            {/* {translations.filter((trans) => trans.code === 'ICS129').map((trans) => trans.text)} */}
            {title}
          </h5>
        </Row>
        <FlourishComponent
          visualizationId='22300629'
          containerId={containerId}
          style={{ width: '100%' }}
          withFooter={false}
          onChartLoad={() => {
            setChartLoaded(true);
          }}
          ref={ref}
          data={{
            state: {
              map_colors: {
                sequential_custom_domain: true,
                sequential_domain_max: max,
              },
            },
            bindings: {
              points: {
                metadata: [],
                value: [],
              },
              regions: {
                id: 0,
                metadata: [1],
                name: 2,
                value: [3],
              },
              regions_geometry: {
                geometry: 0,
                id: [1, 2],
              },
            },
            data: {
              regions: data || [],
            },
            metadata: {
              points: {},
              regions: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                1: {
                  type_id: 'number$comma_point',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
                2: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                3: {
                  type_id: 'number$comma_point',
                  type: 'number',
                  output_format_id: 'number$point_comma',
                },
              },
              regions_geometry: {
                0: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                1: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
                2: {
                  type_id: 'string$arbitrary_string',
                  type: 'string',
                  output_format_id: 'string$arbitrary_string',
                },
              },
            },
          }}
          // dataToRespond={[...extractedData.flat()]}
        />
      </Col>
    </Row>
  );
};

export default RegionalHeatmapChart;
